import { Component, Injector, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { jkBaseForm, PageKind } from "jk-service";
//import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { idNameItem, JkJobService } from 'jk-service';
import { JkaggridComponent } from './jkaggrid/jkaggrid.component';
import { JkgridwinComponent } from './jkgridwin/jkgridwin.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ''
})
export class JkReportComponent extends jkBaseForm {
  masterGrid!: JkgridwinComponent;
  reportTypeList: idNameItem[] = [];
  reportType: string = '';
  job: JkJobService = new JkJobService(); // "報表" 工作管理明細表 ,JkJobKind.Report
  constructor() {
    const injector = inject(Injector);

    super(injector);
    this.pageKind = PageKind.report;
  }
  afterGridReady($event: JkgridwinComponent) {// ###
    this.masterGrid = $event;
    //this.masterGrid.initPage(this.gridInitOpt);
    //this.masterGrid.init(this, 'WD002', 'desc', null);
  }
  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###

  }

  //@ViewChild(DxDataGridComponent, { static: false })
  //masterGrid!: DxDataGridComponent;
  gridWidth: number = window.innerWidth - 10;
  useCache = false;
  masterSrv: any;// JkEntityV2;
  doFilterClick() {

  }
  async refreshData(tableName: string) {
    //if (this.masterGrid)
    //  {this.masterGrid.instance.refresh(false);}
  }
  doGetPreFilter() {
    // TODO:
  }
}
